import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "block",
    class: _vm.defaultClass
  }, [_vm._l(_vm.extFields, function (extField) {
    return [[1, 2, 3, 4, 5, 6, 8, 9, 12, 13, 18].indexOf(extField.type) !== -1 || extField.type === null ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), _c('div', {
      staticClass: "line-value"
    }, [_c('pre', {
      staticStyle: {
        "white-space": "pre-line",
        "word-break": "break-all"
      }
    }, [_vm._v("            " + _vm._s(extField.tfvvalue || '-') + "\n        ")])])]) : [17].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(i18n.tc("342"))]), _c('div', {
      staticClass: "line-value"
    }, [_c('a', {
      staticClass: "main-color",
      attrs: {
        "target": "_blank",
        "href": _vm.spliteHyperLink(extField.tfname)[0]
      }
    }, [_vm._v(" " + _vm._s(_vm.spliteHyperLink(extField.tfname)[1]) + " ")])])]) : [7, 16].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), _c('div', {
      staticClass: "line-value"
    }, [_vm._v(" " + _vm._s(extField.tfvvalue === '1' ? i18n.tc("86") : i18n.tc("87") || '-') + " ")])]) : [10, 26].indexOf(extField.type) !== -1 && _vm.imgViewType === 0 ? [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), _c('div', {
      staticClass: "line-value"
    }, [_vm._v(" " + _vm._s(extField.tfvvalue ? '' : '-') + " ")])]), extField.tfvvalue != null && extField.tfvvalue !== '' ? _c('div', {
      staticClass: "img"
    }, _vm._l(extField.tfvvalue.split(',').filter(function (item) {
      return item;
    }), function (pic, index) {
      return _c('img', {
        key: index,
        attrs: {
          "src": pic
        },
        on: {
          "click": function ($event) {
            return _vm.imgClick(extField, index);
          }
        }
      });
    }), 0) : _vm._e()] : [10, 26].indexOf(extField.type) !== -1 && _vm.imgViewType === 1 ? [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), extField.tfvvalue != null && extField.tfvvalue !== '' ? _c('div', {
      staticClass: "line-value img"
    }, _vm._l(extField.tfvvalue.split(','), function (pic, index) {
      return _c('img', {
        key: index,
        attrs: {
          "src": pic
        },
        on: {
          "click": function ($event) {
            return _vm.imgClick(extField, index);
          }
        }
      });
    }), 0) : _c('div', {
      staticClass: "line-value"
    }, [_vm._v("-")])])] : [11].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), _c('div', {
      staticClass: "line-value"
    }, [_vm._v(" " + _vm._s(extField.tfvvalue ? extField.tfvvalue.split(',')[0] : '-') + " ")])]) : [14].indexOf(extField.type) !== -1 ? [_c('div', {
      key: _vm.i,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-value"
    }, [_vm._v(_vm._s(extField.tfname || '-'))])]), _c('div', {
      key: _vm.i + '-img',
      staticClass: "item-bubble-img instruction-img"
    }, [_c('photo-provider', _vm._l(extField.fieldAttributeList || [], function (image, i) {
      return _c('photo-consumer', {
        key: i,
        attrs: {
          "intro": _vm.$showName(image.value),
          "src": image.value
        }
      }, [_c('img', {
        staticClass: "previewer-demo-img item-bubble-img-i",
        attrs: {
          "src": image.value
        }
      })]);
    }), 1)], 1)] : [15].indexOf(extField.type) !== -1 ? [extField.ovalue ? _vm._l(extField.ovalue.split(','), function (item, index) {
      return _c('div', {
        staticClass: "line"
      }, [_c('div', {
        staticClass: "line-name"
      }, [_vm._v(" " + _vm._s(index === 0 ? extField.tfname : '') + " ")]), _c('div', {
        staticClass: "line-value"
      }, [item ? [_c('div', {
        staticClass: "file",
        style: {
          background: item ? '#F2F2F2' : '#FFF'
        }
      }, [_c('img', {
        staticClass: "img",
        attrs: {
          "src": "/spa_static_mobile/icon/zip89_87@3x.png"
        }
      }), _c('a', {
        attrs: {
          "href": item,
          "download": _vm.translate(item.split('/')[item.split('/').length - 1])
        }
      }, [_vm._v(" " + _vm._s(_vm.translate(item.split('/')[item.split('/').length - 1])) + " ")])])] : _vm._e(), !item ? [_vm._v("-")] : _vm._e()], 2)]);
    }) : [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(" " + _vm._s(extField.tfname) + " ")]), _c('div', {
      staticClass: "line-value"
    }, [_vm._v("-")])])]] : [19].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), _c('div', {
      staticClass: "line-value"
    }, [_vm._v(_vm._s(_vm.calcValue(extField)))])]) : [20].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), _c('div', {
      staticClass: "line-value main-color"
    }, [_c('a', {
      staticClass: "main-color",
      attrs: {
        "href": "tel:" + extField.tfvvalue
      }
    }, [_vm._v(" " + _vm._s(extField.tfvvalue) + " ")]), _c('img', {
      staticClass: "customer-icon",
      attrs: {
        "src": require("@/assets/icon/tel24_24@3x.png")
      }
    })])]) : [21].indexOf(extField.type) !== -1 ? [_c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), extField.realPic ? _c('div', {
      staticClass: "line-value img"
    }, [_c('img', {
      attrs: {
        "src": extField.realPic
      },
      on: {
        "click": function ($event) {
          return _vm.signClick(extField.realPic, 0);
        }
      }
    })]) : _c('div', {
      staticClass: "line-value"
    }, [_vm._v("-")])])] : [22].indexOf(extField.type) !== -1 ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line-name"
    }, [_vm._v(_vm._s(extField.tfname))]), _c('div', {
      staticClass: "line-value"
    }, [_c('Rater', {
      attrs: {
        "disabled": true,
        "value": Number(extField.tfvvalue) || 0,
        "active-color": "#ffb84d",
        "margin": 5,
        "font-size": 20
      }
    })], 1)]) : _vm._e()];
  }), _c('div', [_c('Previewer', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    ref: "previewer",
    attrs: {
      "list": _vm.picList,
      "options": _vm.options
    }
  })], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };